var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"align-center":""}},[_c('div',{staticClass:"profile__stat border-red"},[_vm._v(_vm._s(_vm.number))]),_c('div',{staticClass:"profile__stat-text ml-3 red-text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }